import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const Basic1PageHeader = ({
  page,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <>
      <div className={cn('p-fluid-4', { 'lg:pt-fluid-14': !forceMobile })}>
        <div className="ft-widget page-header-block ft-widget-wrapper p-block pb-fluid-1">
          <div className="flex flex-col space-y-fluid-3">
            <HeaderName
              name={page?.name}
              {...props}
              className="text-fluid-3xl text-page-heading-text"
            />
            <HeaderBanner
              media={page?.bannerMedia}
              {...props}
              className="rounded-page-widget-block h-fluid-48"
            />

            <div className="flex flex-row space-x-fluid-4">
              <div>
                <HeaderLogo
                  media={page?.logoMedia}
                  {...props}
                  className="rounded-page-widget-block"
                  sizeClassName="size-fluid-20"
                  size={80}
                />
              </div>

              <div className="flex-1">
                <HeaderDescription
                  description={page?.description}
                  {...props}
                  className="text-fluid-base"
                />
              </div>
            </div>

            <HeaderSocialIcons
              socialIcons={page?.socialIcons}
              {...props}
              primaryClassName="p-fluid-4 page-header-primary-button flex-1 rounded-page-widget-block!"
              secondaryClassName="p-fluid-4 page-header-secondary-button rounded-page-widget-block!"
            />
          </div>
        </div>
      </div>
    </>
  )
}
